import { render } from "./KnowledgeGraphCanvas.vue?vue&type=template&id=401c2520&scoped=true"
import script from "./KnowledgeGraphCanvas.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraphCanvas.vue?vue&type=script&lang=js"

import "./KnowledgeGraphCanvas.vue?vue&type=style&index=0&id=401c2520&scoped=true&lang=css"
import "./KnowledgeGraphCanvas.vue?vue&type=style&index=1&id=401c2520&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401c2520"]])

export default __exports__